module.exports = __webpack_public_path__ + "media/images/icons/footer-icon-twitter-189b8ec9707d4cc9041de50e018baed8.png";